import {
  AUTH_ERROR_MESSAGES,
  AuthErrorCode,
} from "@ac-expo/api-types";
import { isAxiosError } from "axios";

const BETTERAUTH_MESSAGE_TO_CODE: Record<string, AuthErrorCode> = {
  "Invalid email or password": AuthErrorCode.INVALID_CREDENTIALS,
  "Invalid password": AuthErrorCode.INVALID_CREDENTIALS,
  "User not found": AuthErrorCode.INVALID_CREDENTIALS,
  "Email not verified": AuthErrorCode.EMAIL_NOT_VERIFIED,
  "Account is locked": AuthErrorCode.ACCOUNT_DISABLED,
  "Email already exists": AuthErrorCode.EMAIL_ALREADY_USED,
};

const OTHER_ERROR_TRANSLATIONS: Record<string, string> = {
  "Too many requests": "Trop de tentatives, veuillez réessayer plus tard",
  "Password is too short": "Le mot de passe est trop court",
  "Password is too long": "Le mot de passe est trop long",
  "Invalid token": "Lien invalide ou expiré",
  "Token expired": "Lien expiré, veuillez en demander un nouveau",
  "Session expired": "Session expirée, veuillez vous reconnecter",
};

export type AuthErrorResult = {
  message: string;
  code: AuthErrorCode | null;
};

export const parseAuthError = (errorMessage: string): AuthErrorResult => {
  const code = BETTERAUTH_MESSAGE_TO_CODE[errorMessage] ?? null;
  if (code) {
    return { message: AUTH_ERROR_MESSAGES[code], code };
  }

  const translatedMessage = OTHER_ERROR_TRANSLATIONS[errorMessage];
  if (translatedMessage) {
    return { message: translatedMessage, code: null };
  }

  return { message: errorMessage, code: null };
};

export const translateAuthError = (errorMessage: string): string => {
  return parseAuthError(errorMessage).message;
};

export const getErrorCode = (error: unknown): string | undefined => {
  if (!isAxiosError(error)) return undefined;
  const code = error.response?.data?.code;
  return typeof code === "string" ? code : undefined;
};

export const getErrorMessage = (
  error: unknown,
  defaultMessage = "Une erreur est survenue"
): string => {
  if (isAxiosError(error)) {
    const message = error.response?.data?.message;
    if (typeof message === "string") {
      return message;
    }
    if (Array.isArray(message) && message.length > 0) {
      return message[0];
    }
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === "object" && error !== null && "message" in error) {
    const message = (error as { message: unknown }).message;
    if (typeof message === "string") {
      return message;
    }
    if (Array.isArray(message) && message.length > 0) {
      return message[0];
    }
  }

  return defaultMessage;
};
